export const securityActions = {
    TOKEN : 'TOKEN',
    TOKEN_RECEIVED: 'TOKEN_RECEIVED',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    GET_OIDC_COfIGURATIONS:'GET_OIDC_COfIGURATIONS',
    SET_OIDC_COfIGURATIONS:'SET_OIDC_COfIGURATIONS',
    AUTHENTICATION_METHOD:'AUTHENTICATION_METHOD',
    LOGOUT : 'LOGOUT',
    LOGOUT_SUCCESS : 'LOGOUT_SUCCESS'
};

const initState  = {
    user : null
};

/* todo: remove securityReducer
** not need save user to redux storage because it already exist in local storage
*/

export const securityReducer = (state = initState, action: any) => {

    switch (action.type) {
        case 'LOAD_USER':
            return Object.assign({}, state, action.payload);

        case securityActions.TOKEN_RECEIVED:
            return Object.assign({}, state, action.payload);

        case securityActions.LOGOUT_SUCCESS:
            return Object.assign({}, state, initState);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/securityReducer.ts